<section class="what-is" id="what-is">
    <div class="container">
        <h2 class="section-title mx-auto text-start">
            {{ 'what_is.title' | translate }}
        </h2>
        <p class="section-desc text-start">{{ 'what_is.desc' | translate }}</p>
        <div class="main-cards-wrapper pt-5 mb-3">
            <div class="main-cards d-flex flex-column">
                <span class="mb-3 font-30 title">{{'what_is.main_card_1.title' | translate}}</span>
                <span class="mb-3 font-16">{{'what_is.main_card_1.desc' | translate}}</span>
                <span class="font-16">{{'what_is.main_card_1.point_1' | translate}}</span>
                <span class="font-16">{{'what_is.main_card_1.point_2' | translate}}</span>
                <span class="mb-3 font-16">{{'what_is.main_card_1.point_3' | translate}}</span>
                <span class="mb-3 font-16 text-primary">{{'what_is.main_card_1.stable_index' | translate}}</span>
                <span class="font-16">{{'what_is.main_card_1.info' | translate}}</span>

            </div>
            <div class="main-cards d-flex flex-column ">
                <span class="mb-3 font-30 title">{{'what_is.main_card_2.title' | translate}}</span>
                <div class="pointer d-flex" *ngFor="let point of checkPoints">
                    <img src="assets/images/svg-icons/green-tick.svg" alt="Green Tick" loading="lazy">
                    <span>{{point | translate}}</span>
                </div>
            </div>
        </div>

        <div class="regulatory-design d-flex flex-column gap-4">
            <p class="font-24 text-center design-title mb-0">{{ "what_is.design_title" | translate}}</p>
            <div class="design-cards gap-3">
                <div class="design-card d-flex flex-column gap-0 gap-md-2 justify-content-center"
                    *ngFor="let card of designCards">
                    <span class="font-16 text-center">{{ card.title | translate }}</span>
                    <span class="font-16 text-center">{{ card.content | translate }}</span>
                </div>
            </div>
        </div>
    </div>
    <img src="/assets/images/webp/why-top-bg.webp" alt="bg-img" loading="lazy" class="img-fluid top-bg">
    <img src="/assets/images/webp/why-bottom-bg.webp" alt="bg-img" loading="lazy" class="img-fluid bottom-bg">
</section>
<div class="statistics">
    <div class="container">
        <div class="stats-container">
            <div class="stat d-flex flex-column align-items-center" *ngFor="let stat of stats">
                <span class="gradient-text">
                    {{stat.symbol}}<span appCountUp [targetNumber]="stat.value" [duration]="2500"
                        [decimals]="stat.decimals">{{
                        stat.value }}</span>{{stat.suffix}}
                </span>
                <span class="font-16 stat-title">{{stat.txt | translate}}</span>
            </div>
        </div>

    </div>
</div>